import React, { useState, useEffect, useContext } from 'react';
import { withStyles } from "@material-ui/core/styles";
import { PRIMARY_COLOR, WHITE_BG, GRAY_BG_F7, CAMPAIGNLIST_FILTER_LI_STYLES } from '../../../utils/CssConstants';
import TableData from './TableData/TableData';
import GetGlobalCouponListApi from '../../../services/GlobalCoupon/GetGlobalCouponListApi';
import Pagination from '@mui/material/Pagination';
import { AppContext } from '../../../utils/AppContext';

const styles = theme => ({
    rootUsers: {
        display: 'flex',
        background: WHITE_BG,
        margin: '30px 10px',
        padding: 15,
        borderRadius: 20
    },
    componentCont: {
        background: GRAY_BG_F7,
        width: '100%',
        borderRadius: 30,
        minHeight: '100vh',
        height: 'auto',
    },
    loaderContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
    },
    campaignListTop: {
        margin: 30,
        marginLeft: 50,

        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'baseline',
        [theme.breakpoints.down('sm')]: {
            margin: '20px 20px'
        }
    },
    campaignListHeading: {
        fontFamily: 'Poppins',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 24,
        marginBottom: 20,
        width: '15%',
        [theme.breakpoints.down('sm')]: {
            width: '20%'
        }
    },
    campaignListFilters: {
        display: 'flex',
        listStyle: 'none',

        padding: 0,
        margin: 0,
    },
    filterStyles: CAMPAIGNLIST_FILTER_LI_STYLES,
    filterActive: {
        color: PRIMARY_COLOR,
        fontWeight: 600
    },
    campaignListContent: {
        width: '100%',
        marginBottom: 20,
        [theme.breakpoints.down('sm')]: {
            overflowX: 'auto'
        }
    },
    campaignListTable: {
        width: '100%',
        display: 'flex',
        padding: '0px 0px',
        flexDirection: 'column',
        [theme.breakpoints.down('sm')]: {
            width: 1400
        }
    },
    campaignListTheadRow: {
        display: 'flex',
        background: WHITE_BG,
        border: '1px solid #000000',
        boxSizing: 'border-box',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: 10,
        padding: '15px 30px',
        width: '100%',
        minHeight: '12%',
        flexWrap: 'wrap',
        marginBottom: 10,
        justifyContent: 'center',
        alignItems: 'center',
    },
    campaingListHeadings: {
        fontFamily: 'Poppins',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 20,
        padding: '5px 10px',
        borderRight: '1px solid #CECECE',
        textAlign: 'center',
        height: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    smallSpace: {
        flex: 1
    },
    mediumSpace: {
        flex: 3
    },
    mediumSpaceTwo: {
        flex: 4
    },
    largeSpace: {
        flex: 7
    },
    campaignListBottom: {
        padding: '20px 0',
        display: 'flex',
        justifyContent: 'center',
        '&:before': {
            background: 'black'
        }
    },
    campaignPhoto: {
        borderRadius: 10,
        width: 180,
        height: 180,
        objectFit: 'cover'
    },
    campaignName: {
        color: '#000',
        textDecoration: 'underline',
        cursor: 'pointer',
        "&:hover": {
            color: '#37B1C8',
            textDecoration: 'underline',
            cursor: 'pointer'
        }
    },
    actionIcons: {
        "& > *": {
            marginRight: 15,
            cursor: 'pointer',
        }
    },
    filterBtn: {
        fontFamily: 'Poppins',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: 20,
        border: '1px solid #FFF',
        background: WHITE_BG,
        borderRadius: 10,
        marginLeft: 15,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        outline: 'none',
        padding: '0px 15px'
    },
    filterList: {
        position: 'absolute',
        top: 45,
        left: 15,
        zIndex: 1000,
        display: 'block',
        listStyle: 'none',
        width: 125,
        margin: 0,
        padding: 0,
    },
    filterOption: {
        fontFamily: 'Poppins',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: 20,
        letterSpacing: '0.05em',
        background: WHITE_BG,
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        width: 118,
        height: 35,
        textAlign: 'center',
        cursor: 'pointer',
        '&:hover': {
            color: '#262626',
            backgroundColor: '#f5f5f5',
            borderLeft: '3px solid #1549d6'
        }
    },
    statusList: {
        listStyle: 'none',
        width: 108,
        margin: 0,
        padding: 0,
    },
    statusDropdown: {
        position: 'absolute',
        top: 35,
        zIndex: 1000,
        display: 'block',
    },
    searchContainer: {
        width: '25%',
        display: 'flex',
        position: 'relative',
        marginLeft: 15,
        [theme.breakpoints.down('sm')]: {
            width: '80%'
        }
    },
    statusActive: {
        color: '#1e7e34',
        background: '#e6f4ea',
        padding: '6px 12px',
        borderRadius: '50px',
        fontSize: '14px',
        fontWeight: 500,
    },
    statusInactive: {
        color: '#dc3545',
        background: '#feecea',
        padding: '6px 12px',
        borderRadius: '50px',
        fontSize: '14px',
        fontWeight: 500,
    },
    actionIcon: {
        color: PRIMARY_COLOR,
        cursor: 'pointer',
        fontSize: '18px',
        '&:hover': {
            opacity: 0.8
        }
    }
});

const GlobalCouponList = ({ classes }) => {
    const { loader, setLoader } = useContext(AppContext);
    const [couponData, setCouponData] = useState([]);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 10;

    const fetchCoupons = async (pageNumber = 1) => {
        try {
            setLoader(true);
            const response = await GetGlobalCouponListApi(pageNumber, pageSize);
            console.log('API Response:', response);

            if (response instanceof Error) {
                throw response;
            }

            if (response && response.status === 'SUCCESS' && response.data) {
                console.log('Setting coupon data:', response.data.coupon_code_details_model);
                setCouponData(response.data.coupon_code_details_model);
                setTotalPages(response.data.total_count);
            } else {
                console.warn('Unexpected response structure:', response);
                setCouponData([]);
            }
            setError(null);
        } catch (err) {
            console.error('Error fetching coupons:', err);
            setError(err.message || 'Failed to fetch coupons');
            setCouponData([]);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchCoupons(page);
    }, [page]);

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    console.log('Coupon Data:', totalPages, Math.ceil(totalPages / 10));

    return (
        <div className={classes.campaignListContent}>
            <table className={classes.campaignListTable}>
                <thead>
                    <tr className={classes.campaignListTheadRow}>
                        <th className={`${classes.campaingListHeadings} ${classes.mediumSpaceTwo}`} id="coupon-code">Coupon Code</th>
                        <th className={`${classes.campaingListHeadings} ${classes.mediumSpaceTwo}`} id="total-amount">Coupon Amount</th>
                        <th className={`${classes.campaingListHeadings} ${classes.mediumSpace}`} id="status">Status</th>
                        <th className={`${classes.campaingListHeadings} ${classes.mediumSpace}`} id="created-date">Created Date</th>
                    </tr>
                </thead>
                <TableData
                    data={couponData}
                    loading={loader}
                    error={error}
                    onRefresh={() => fetchCoupons(page)}
                />
            </table>
            {!loader && (
                <div className={classes.campaignListBottom}>
                    <Pagination
                        count={Math.ceil(totalPages / 10)}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        showFirstButton
                        showLastButton
                    />
                </div>
            )}
        </div>
    );
};

export default withStyles(styles)(GlobalCouponList); 